import { NgModule } from '@angular/core';
import { provideLazyLoad } from '@core/jss-utils';
import { CoreTranslateModule, provideTranslationLoader } from '@core/translate';
// eslint-disable-next-line @nx/enforce-module-boundaries
import {
  ReviewEntryContainerComponent,
  ReviewOverviewContainerComponent,
  ReviewScoreContainerComponent,
  ReviewSingleContainerComponent,
  ReviewsLegacyModule,
} from '@reviews/legacy';

import { ReviewEntrySectionContainerComponent } from './review-entry-section-container/review-entry-section-container.component';

const namespace = 'reviewsFeature';

@NgModule({
  imports: [
    ReviewsLegacyModule,
    CoreTranslateModule,
    provideLazyLoad({
      ReviewEntrySection: ReviewEntrySectionContainerComponent,

      // Legacy components (only compatible with DynamicRow)
      Review: ReviewSingleContainerComponent,
      ReviewScoreWidget: ReviewScoreContainerComponent,
      ReviewEntry: ReviewEntryContainerComponent,
      ReviewOverview: ReviewOverviewContainerComponent,
    }),
  ],
  providers: [
    provideTranslationLoader(
      namespace,
      // We do not want webpack to automatically include all files since we also have .html files in this library.
      // This is why we specify that only json files need to be imported dynamically. This will be fixed within the provideTranslationLoader in ATL-2676
      (path) => import(`${path.slice(0, -5)}.json`)
    ),
  ],
})
export class ReviewsLazyModule {}
